import React from 'react';
    import { motion } from 'framer-motion';
    import { Link } from 'react-router-dom';
    import Button from './Button';

    const AboutSection = () => {
      return (
        <section className="py-20 lg:py-32 bg-white">
          <div className="max-w-6xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }} viewport={{ once: true }} className="order-2 lg:order-1" >
                <div className="mb-6">
                  <span className="text-sage-600 font-inter text-sm font-medium uppercase tracking-wider"> About Katie </span>
                </div>
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-canela font-light text-gray-900 mb-8 leading-tight"> Supporting Women Through Life's Most Challenging Transition </h2>
                <div className="space-y-6 text-gray-600 font-inter leading-relaxed text-lg">
                  <p> Having walked through my own divorce journey, I understand the overwhelming mix of emotions, decisions, and uncertainties that come with this life transition. </p>
                  <p> What started as my personal healing process became my calling to help other women navigate this challenging time. As part of my service, I provide a safe, non-judgmental space where you can process your feelings and gain clarity. </p>
                  <p> Together, we'll create a clear strategy that not only helps you feel empowered but also gives you the confidence to take back control of your future. My approach combines practical guidance with emotional support, helping you move from surviving to thriving. </p>
                </div>
                <div className="mt-10 flex flex-col sm:flex-row gap-4">
                  <a href="https://tidycal.com/dwd/discovery-call" target="_blank" rel="noopener noreferrer" >
                    <Button variant="primary"> Schedule Free Discovery Call </Button>
                  </a>
                  <Link to="/services">
                    <Button variant="outline"> View Services </Button>
                  </Link>
                </div>
              </motion.div>
              <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }} viewport={{ once: true }} className="order-1 lg:order-2" >
                <div className="relative">
                  <img src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758643420584-forest%201.jpg" alt="Woman celebrating freedom" className="w-full h-96 lg:h-[500px] object-cover rounded-2xl shadow-2xl" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent rounded-2xl"></div>
                </div>
              </motion.div>
            </div>
          </div>
        </section>
      );
    };

    export default AboutSection;